var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from "../../../ui/Input/Input";
import Label from "../../../ui/Label/Label";
import BetCountButtons from "./BetCount.buttons";
import { useGameContext } from "../../../game/GameContext/GameContext";
import { useEffect, useMemo, useState } from "react";
import { InputWithLabelContainer } from "../../../game/GameContainer/GameContainer.styled";
var BetCount = function () {
    var _a = useGameContext(), autoPlayOptions = _a.autoPlayOptions, setAutoPlayOptions = _a.setAutoPlayOptions, inProgress = _a.inProgress, autoPlayInProgress = _a.autoPlayInProgress, controlPanelDisabled = _a.controlPanelDisabled;
    var _b = useState(autoPlayOptions.betCount.toString()), localBetCount = _b[0], setLocalBetCount = _b[1];
    useEffect(function () {
        setLocalBetCount(autoPlayOptions.betCount === -1 ? "∞" : autoPlayOptions.betCount.toString());
    }, [autoPlayOptions]);
    var updateBetCount = function (event) {
        setLocalBetCount(event.target.value);
    };
    var handleBlur = function () {
        var parsedBetCount = parseInt(localBetCount);
        setAutoPlayOptions(function (prevOptions) { return (__assign(__assign({}, prevOptions), { betCount: isNaN(parsedBetCount) || parsedBetCount <= 0 ? -1 : parsedBetCount })); });
    };
    var isDisabled = useMemo(function () {
        return inProgress || autoPlayInProgress || controlPanelDisabled;
    }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    return (_jsxs(InputWithLabelContainer, { children: [_jsx(Label, { children: "Number of bets" }), _jsx(Input, { type: localBetCount !== "∞" ? "number" : "text", min: localBetCount !== "∞" ? 0 : undefined, step: localBetCount !== "∞" ? 1 : undefined, variant: "default", value: localBetCount, placeholder: "\u221E", disabled: isDisabled, onChange: updateBetCount, onBlur: handleBlur, rightContent: _jsx(BetCountButtons, {}) })] }));
};
BetCount.displayName = "BetCount";
export default BetCount;
//# sourceMappingURL=BetCount.js.map